<script setup lang="ts">
import { ref, onMounted, type Ref } from 'vue'
import {
  fetchDocument,
  insertFetchedDocument,
  dataToHtmlElement,
} from '@/components/docModalFetch'

const props = defineProps<{
  contentUrl: string
  backupUrl: string
  modalId: string
  header: string
}>()

const modal = ref(null) as Ref<null> | Ref<HTMLElement>
const content = ref(null) as Ref<null> | Ref<HTMLElement>
const loadingError = ref(false)
const showLoadingMessage = ref(true)

onMounted(() => {
  if (modal.value !== null) {
    modal.value.addEventListener('shown.bs.modal', async () => {
      // Return if content already exists
      if (
        content.value &&
        content.value.querySelector('#swiftaid-legal-doc-target-content') !==
          null
      ) {
        return
      }

      try {
        const { data } = await fetchDocument(props.contentUrl)
        insertFetchedDocument(content.value, dataToHtmlElement(data))
      } catch (error) {
        loadingError.value = true
        console.error('An error occurred', error)
      } finally {
        showLoadingMessage.value = false
      }
    })
  }
})
</script>

<template>
  <div
    :id="modalId"
    ref="modal"
    class="modal fade text-start"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`${modalId}-label`"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 :id="`${modalId}-label`" class="modal-title">
            {{ header }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div
          :id="`${modalId}-legal-doc-modal-content`"
          class="swiftaid-legal-doc modal-body text-left p-4"
          ref="content"
        >
          <span v-if="loadingError" class="msg">
            <a :href="backupUrl" target="_blank">
              {{ $t('genericModal.viewInNewWindow') }}
            </a>
          </span>
          <span v-if="showLoadingMessage">
            {{ $t('genericModal.fetchingContentMessage') }}
          </span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            {{ $t('genericModal.closeModal') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
